import { useMemo } from 'react';

import { Prettify } from '../utils/typing';

type PropsToBeGrouped<OwnPropsType, SelectedPropsType, ActionsPropsType, OtherPropsType> = {
  ownProps?: OwnPropsType;
  selectedProps?: SelectedPropsType;
  actionsProps?: ActionsPropsType;
  otherProps?: OtherPropsType;
};

const useMergeProps = <OwnPropsType, SelectedPropsType, ActionsPropsType, OtherPropsType>({
  ownProps = {} as OwnPropsType,
  selectedProps = {} as SelectedPropsType,
  actionsProps = {} as ActionsPropsType,
  otherProps = {} as OtherPropsType,
}: Prettify<PropsToBeGrouped<OwnPropsType, SelectedPropsType, ActionsPropsType, OtherPropsType>>) =>
  useMemo(
    () => ({
      ...ownProps,
      ...selectedProps,
      ...actionsProps,
      ...otherProps,
    }),
    [actionsProps, ownProps, selectedProps, otherProps],
  );

export default useMergeProps;
